import React from 'react';

import { EditUserPhotoDialog } from './EditUserPhotoDialog';
import { ProfilePictureStyles } from './styles/ProfilePictureStyles';
import { UserProfilePicture } from './UserProfilePicture';

export class EditableUserProfilePicture extends React.Component<EditableUserProfilePicture.Props,
  EditableUserProfilePicture.State> {

  constructor(props: EditableUserProfilePicture.Props) {
    super(props);
    this.state = {
      inEditMode: false
    };
  }

  render() {
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      this.props.allowEdit? (
        <div style={{cursor: 'pointer'}}
             onClick={() => this.handleClick()}>
          <UserProfilePicture
            testId="user-place-icon"
            imageUrl={this.props.imageUrl}
            profileDisplayName={this.props.profileDisplayName}
            imageSize={ProfilePictureStyles.Sizes.MediumIconSize}
            fontSize={ProfilePictureStyles.FontSizes.MediumIconFontSize}
          />
          {this.state.inEditMode ? this.EditPhotoDialog() : null}
        </div>
      ) : (
        <div>
          <UserProfilePicture
            testId="user-place-icon"
            imageUrl={this.props.imageUrl}
            profileDisplayName={this.props.profileDisplayName}
            imageSize={ProfilePictureStyles.Sizes.MediumIconSize}
            fontSize={ProfilePictureStyles.FontSizes.MediumIconFontSize}
          />
        </div>
      )
    );
  }

  private EditPhotoDialog(): JSX.Element {
    return <EditUserPhotoDialog
      imageUrl={this.props.imageUrl}
      profileDisplayName={this.props.profileDisplayName}
      onEditModeUpdate={(inEditMode: boolean) =>
        this.setState({inEditMode: inEditMode})
      }
      imageValidator={(imageFile: Blob, callBack) => {
        this.props.imageValidator(imageFile, callBack);
      }}
      handleSubmit={(userImage: Blob) => this.props.handleSubmit(userImage)}
    />;
  }

  private handleClick() {
    this.setState({inEditMode: true});
  }

}

export module EditableUserProfilePicture {

  export interface Props {
    profileDisplayName: string;
    imageUrl: string;
    allowEdit: boolean;
    imageValidator?: (imageFile: Blob, callback: (isValidImage: boolean) => void) => void;
    handleSubmit?: (userImage: Blob) => void;
  }

  export interface State {
    inEditMode: boolean;
  }

}
